import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskForgeAppsRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-forge-apps',
	path: '/jira/servicedesk/projects/:projectKey/settings/apps/:appId/:envId/:route?',
};
